import Vue from 'vue'
import App from './App.vue'
import zTable from '@common/components/z-table/fixed-table'
import zCell from '@common/components/z-table/align-cell'
import commonSvg from '@common/components/commonSvg'
import axios from 'axios'
import './plugins/element.js'
import '../theme/index.css'
import './style/common.scss'

import './js/http.js'
import commonUtils from '@common/js/utils'
import utils from './js/utils.js'
import store from './vuex/store'
import Vuex from 'vuex'
import VueClipboard from 'vue-clipboard2'
import router from './router'
import '../static/font/iconfont'
import contactBox from './components/contactBox.vue'
import VueI18n from 'vue-i18n'
import './js/index'
import gaPulgin from './plugins/ga-analyze'
import SliderVerify from 'slider-verify-v2'
import 'slider-verify-v2/lib/SliderVerify.css'
import { resolveInitialLocale, setI18nInstance } from '@/js/common'
import VueMeta from 'vue-meta'

Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(gaPulgin)
Vue.use(VueI18n)
Vue.use(SliderVerify)

Vue.config.productionTip = false
Vue.component('zTable', zTable)
Vue.component('zCell', zCell)
Vue.component('commonSvg', commonSvg)
Vue.use(commonUtils)
Vue.use(utils)
Vue.use(Vuex)
Vue.use(VueClipboard)
Vue.component('contactBox', contactBox)

Vue.prototype.$EventBus = new Vue() // 全局注册一个事件总线

var defaultlocale = resolveInitialLocale()
var i18n
var fillInPage = (function() {

  var pageMount = function(lang){
    i18n = new VueI18n({ // 双语
      locale: lang,
      messages: {
        'zh': require('./js/lang/zh?v=260804'),
        'en': require('./js/lang/en?v=260804'),
      },
    })
    setI18nInstance(i18n)
    new Vue({
      i18n,
      render: h => h(App),
      router,
      store,
    }).$mount('#app')
  }

  
  return function() {
    pageMount(defaultlocale)
  }
  // return function() {
  //   axios
  //   .post('/api/accounts/get_country_code/')
  //   .then(res => {
  //     let whiteList=['HK','CH','MO','TW']
  //     if(whiteList.indexOf(res.country)>-1){
  //       defaultlocale = 'zh'  
  //     }else{
  //       defaultlocale = 'en'
  //     }
  //     pageMount(defaultlocale)
  //   })
  //   .catch(err => {
  //     pageMount(defaultlocale)
  //     console.log(err);
  //   })
  // };
}());


fillInPage();



















